// src/App.js
import React, { useState } from "react";
import Login from "./Login";
import Main from "./Main";

const App = () => {
  const [username, setUsername] = useState("");

  return (
    <>
      {username ? (
        <Main username={username} onLogout={() => setUsername("")} />
      ) : (
        <Login onLogin={(username) => setUsername(username)} />
      )}
    </>
  );
};

export default App;
